var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',{attrs:{"title":_vm.informationTitle,"hasMainBtn":false,"customShowDialog":_vm.showInformationModal},on:{"close":_vm.handleClose}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('span',{staticClass:"modal-text",domProps:{"innerHTML":_vm._s(_vm.informationBody)}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b8454a5","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/InformationModal.vue
// module id = null
// module chunks = 